import { useCollectPaymentMultiContext } from '../../../collect-payment-multi.context';
import { useTerminalStepStripeContext } from '../../terminals/terminal-step-context/terminal-step-context-stripe';
import { useTerminalReadersQuery } from '../../terminals/use-terminal-readers-query';
import { CollectTerminalNavigationSwitch } from './collect-terminal-navigation-switch';
import { CollectTerminalStep } from './collect-terminal-step';
import { CollectTerminalStepBodyProps } from './collect-terminal.types';

export const CollectTerminalStripe = () => {
  return <CollectTerminalNavigationSwitch body={CollectTerminalStripeBody} />;
};

const CollectTerminalStripeBody = ({
  onGoBack,
  onCloseWithoutReceipt,
  onInvoiceSent,
  onPaymentSuccess,
}: CollectTerminalStepBodyProps) => {
  const {
    activeLocationId,
    invoice,
    paymentsUrl,
    stripeData: { stripeLocationId },
  } = useCollectPaymentMultiContext();

  const { selectedReader, setSelectedReader } = useTerminalStepStripeContext();

  const locationId = invoice?.locationId || activeLocationId;

  const { readers, refetchReadersAsync } = useTerminalReadersQuery({
    locationId,
    stripeLocationId,
    paymentsUrl: paymentsUrl ?? null,
  });

  return (
    <CollectTerminalStep
      readers={readers}
      selectedReader={selectedReader}
      onGoBack={onGoBack}
      onInvoiceSent={onInvoiceSent}
      refetchReaders={refetchReadersAsync}
      onPaymentSuccess={onPaymentSuccess}
      setSelectedReader={setSelectedReader}
      onCloseWithoutReceipt={onCloseWithoutReceipt}
    />
  );
};
